import { useQuery } from '@tanstack/react-query';

import type { ScopeEntity } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';

interface ScopeEntitiesResponse {
  entities: ScopeEntity[];
}

export const useScopeEntities = () =>
  useQuery({
    queryKey: ['extranet', 'scope', 'entities'] as const,
    queryFn: () =>
      getExtranetApi().get<Record<string, never>, ScopeEntitiesResponse>('/v1/extranet/scope/entities', {}),
    staleTime: 5 * 60 * 1000,
  });
